import { render } from "./PlayerOne.vue?vue&type=template&id=091614c4&scoped=true"
import script from "./PlayerOne.vue?vue&type=script&lang=js"
export * from "./PlayerOne.vue?vue&type=script&lang=js"

import "./PlayerOne.vue?vue&type=style&index=0&id=091614c4&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091614c4"]])

export default __exports__